module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-wechat-jssdk-315.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/wechat/vue-wechat-jssdk.md
// module id = 783
// module chunks = 202